import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import i18n from 'cityads-v3/i18n';
import moment from 'moment';
import { slugify } from 'transliteration';

import ClickableCardWithPopup from 'cityads-v3/components/CardWithPopup/ClickableCardWithPopup';

@connect(
  (state, props) => ({
    language: state.language.language,
  })
)
@withTranslation(['main'], { i18n, wait: !!window })
export default class NewsCard extends Component {

  static propTypes = {
    id:           PropTypes.number,
    title:        PropTypes.string,
    image:        PropTypes.string,
    text:         PropTypes.node,
    moreTitle:    PropTypes.string,
    moreText:     PropTypes.node,
    date_publish: PropTypes.string,
    language:     PropTypes.string,
  }

  getDate() {
    require('moment/locale/ru');
    require('moment/locale/pt');
    require('moment/locale/pl');
    moment.locale(this.props.language);
    return moment(this.props.date_publish)
      .format('D MMMM’YY');
  }

  render() {
    const { t, match, id, title, text} = this.props;

    return (
      <ClickableCardWithPopup
        title={title}
        subtitle={this.getDate()}
        moreButtonTitle={t('learn_more')}
        dataReady={true}
        {...this.props}
        morePath={`${match.url}/${id}(-${slugify(title)})?`}
        moreLink={`${match.url}/${id}-${slugify(title)}`}
        lessLink={match.url}
      >
        {text}
      </ClickableCardWithPopup>
    );
  }

}
